import { observer } from 'mobx-react';
import { T, TPlainTextKey } from '../../../../../Translations';
import ParticipantsV2Store from '../../Store';
import SortHeader from './SortHeader';

interface Props {
  store: ParticipantsV2Store;
}

const PlainHeader = ({ label }: { label: TPlainTextKey }) => (
  <th
    className="px-4 py-3 text-left"
    style={{ fontSize: 'var(--text-sm)', fontWeight: 'var(--font-weight-medium)' }}
  >
    <T kind={label} />
  </th>
);

function Head({ store }: Props) {
  return (
    <thead className="border-b border-border">
      <tr className="text-muted-foreground">
        <SortHeader
          store={store}
          column="name"
          label="Person"
          intercomTarget="people-v2-sort-person-button"
        />
        <PlainHeader label="Groups" />
        <PlainHeader label="License" />
        <SortHeader
          store={store}
          column="last_sign_in_at"
          label="Last login"
          intercomTarget="people-v2-sort-last-login-button"
        />
      </tr>
    </thead>
  );
}

export default observer(Head);
